/**
 * Restores analytics for a returning visitor who has already consented.
 *
 * The banner only fires the loader on the click that grants consent, so
 * without this the tag would never load again on later visits. Nothing loads
 * unless the stored value is an explicit accept — a stored rejection, or no
 * cookie at all, leaves the site untagged.
 */
const {
  CONSENT_COOKIE,
  CONSENT_ACCEPTED,
  loadAnalytics,
  trackEvent,
} = require("./src/utils/analytics")

const readCookie = name =>
  document.cookie
    .split("; ")
    .find(row => row.startsWith(`${name}=`))
    ?.split("=")[1]

exports.onClientEntry = () => {
  if (readCookie(CONSENT_COOKIE) === CONSENT_ACCEPTED) {
    loadAnalytics()
  }

  // Phone and email clicks are leads for this business, alongside the form.
  // Delegated rather than wired per call site, so it also covers links inside
  // WordPress content injected via dangerouslySetInnerHTML.
  document.addEventListener(
    "click",
    event => {
      const link = event.target.closest?.("a[href^='tel:'], a[href^='mailto:']")
      if (!link) return

      const isPhone = link.getAttribute("href").startsWith("tel:")
      trackEvent(isPhone ? "contact_phone_click" : "contact_email_click", {
        link_url: link.getAttribute("href"),
      })
    },
    { passive: true }
  )
}
